import fetch from './fetch'

export function getQuestionBookmarks(
  id: number
): Promise<api.question.GetQuestionBookmarksResponse> {
  return fetch.get(`/question_bookmarks?unit_id=${id}`).then(res => res.data)
}

export function addQuestionBookmark(id: number): Promise<api.EmptyResponse> {
  return fetch
    .post(`/question_bookmarks`, { question_id: id })
    .then(res => res.data)
}

export function deleteQuestionBookmark(id: number): Promise<api.EmptyResponse> {
  return fetch.delete(`/question_bookmarks/${id}`).then(res => res.data)
}

export function submitQuestionFeedback(
  questionId: number,
  content: string
): Promise<api.EmptyResponse> {
  return fetch
    .post(`/issues`, { question_id: questionId, content })
    .then(res => res.data)
}

// 設問チェック用
export function getQuestionByName(
  questionName: string
): Promise<api.question.GetQuestionByNameResponse> {
  return fetch
    .get(`/questions/check?name=${questionName}`)
    .then(res => res.data)
}
